import React from 'react';
import Header from '../components/header';
import Footer from '../components/footer';
import './home.css';

function Home() {
  
  const appItems = [
    { image: '../images/chinesevb.png', title: 'Chinese VB+', description: 'Support your Chinese study with Chinese VB+, an app providing topic based study with almost no translation. It is an assistant to your regular Chinese classes by letting you review words by topic and use flashcards and quizzes to fill out your vocabulary. You can also read lessons on important grammar points and practice building sentences in Chinese.' },
    { image: '../images/memoriseThis.png', title: 'Memorise This', description: 'Memorise anything with this easy to use little app. Upload prose, scripts, poetry or lists of items and then practice memorising with only first words displayed for sentences and only first letters for lists.' },
    { image: '../images/spanishvb.png', title: 'Spanish VB', description: 'Support your Spanish study with Spanish VB, an app providing topic based study with almost no translation. It is an assistant to your regular Spanish classes by letting you review words by topic and use flashcards and quizzes to fill out your vocabulary.' },
    { image: '../images/frenchvb.png', title: 'French VB', description: 'Support your French study with French VB, an app providing topic based study with almost no translation. It is an assistant to your regular French classes by letting you review words by topic and use flashcards and quizzes to fill out your vocabulary.' },
    { image: '../images/italianvb.png', title: 'Italian VB', description: 'Support your Italian study with Italian VB, an app providing topic based study with almost no translation. It is an assistant to your regular Italian classes by letting you review words by topic and use flashcards and quizzes to fill out your vocabulary.' },
    { image: '../images/germanvb.png', title: 'German VB', description: 'Support your German study with German VB, an app providing topic based study with almost no translation. It is an assistant to your regular German classes by letting you review words by topic and use flashcards and quizzes to fill out your vocabulary.' },
    { image: '../images/englishvb.png', title: 'English VB', description: 'Support your English study with English VB, an app providing topic based study. It is an assistant to your regular English classes by letting you review words by topic and use flashcards and quizzes to fill out your vocabulary.' },
    { image: '../images/fastflashcards.png', title: 'Fast Flashcards', description: 'Fast Flashcards is a simple, effective flashcard app built around daily study goals and spaced repetition. The app automatically prioritizes overdue reviews, introduces new cards at the right time, and tracks your progress as you build a consistent study habit. Organize decks into folders, import cards in bulk, study individual decks, track your streak, and resume your sessions exactly where you left off—all in a clean, distraction-free interface.' },


    // Add more app items here
  ];

  return (
    <div className="app-home">
      <Header />
      <div className="content-container main-content">
        <div className="introduction">
          <h1>Welcome to EducationVB</h1>
          <p>
            Explore our amazing apps available on iOS and Google Play. 
            Find something that suits your needs, and dive into the experience.
          </p>
        </div>

        <div className="app-grid">
          {appItems.map((app, index) => (
            <div className="app-card" key={index}>
              <img src={app.image} alt={app.title} />
              <h3>{app.title}</h3>
              <p>{app.description}</p>
            </div>
          ))}
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Home;
